"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertInsight = exports.convertInsightDefinition = exports.convertInsightContent = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var omitBy_1 = tslib_1.__importDefault(require("lodash/omitBy"));
var ReferenceConverter_1 = require("../fromBackend/ReferenceConverter");
var PropertiesConverter_1 = require("../fromBackend/PropertiesConverter");
var FilterConverter_1 = require("./FilterConverter");
var MeasureConverter_1 = require("./MeasureConverter");
var convertAttribute = function (attribute) {
    var alias = sdk_model_1.attributeAlias(attribute);
    return {
        visualizationAttribute: tslib_1.__assign({ localIdentifier: sdk_model_1.attributeLocalId(attribute), displayForm: sdk_model_1.attributeDisplayFormRef(attribute) }, (alias && { alias: alias })),
    };
};
var convertBucketItem = function (bucketItem) {
    return sdk_model_1.isMeasure(bucketItem) ? MeasureConverter_1.convertMeasure(bucketItem) : convertAttribute(bucketItem);
};
var convertBucket = function (bucket) {
    var totals = bucket.totals;
    return tslib_1.__assign({ items: bucket.items.map(convertBucketItem), localIdentifier: bucket.localIdentifier }, (!isEmpty_1.default(totals) && { totals: totals }));
};
/**
 * @internal
 */
exports.convertInsightContent = function (insight) {
    var _a = ReferenceConverter_1.convertUrisToReferences({
        properties: sdk_model_1.insightProperties(insight),
        references: {},
    }), properties = _a.properties, references = _a.references;
    var nonEmptyProperties = omitBy_1.default(properties, function (value, key) { return key !== "controls" && isEmpty_1.default(value); });
    var filters = sdk_model_1.insightFilters(insight).map(FilterConverter_1.convertExtendedFilter);
    return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ buckets: sdk_model_1.insightBuckets(insight).map(convertBucket), visualizationClass: { uri: sdk_model_1.insightVisualizationUrl(insight) } }, (!isEmpty_1.default(nonEmptyProperties) && {
        properties: PropertiesConverter_1.serializeProperties(nonEmptyProperties),
    })), (!isEmpty_1.default(filters) && { filters: filters })), (!isEmpty_1.default(references) && { references: references }));
};
/**
 * @internal
 */
exports.convertInsightDefinition = function (insight) {
    return {
        content: exports.convertInsightContent(insight),
        meta: {
            title: sdk_model_1.insightTitle(insight),
            category: "visualizationObject",
        },
    };
};
/**
 * @internal
 */
exports.convertInsight = function (insight) {
    var convertedDefinition = exports.convertInsightDefinition(insight);
    var locked = sdk_model_1.insightIsLocked(insight);
    return {
        content: convertedDefinition.content,
        meta: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, convertedDefinition.meta), { identifier: sdk_model_1.insightId(insight), uri: sdk_model_1.insightUri(insight), created: sdk_model_1.insightCreated(insight), updated: sdk_model_1.insightUpdated(insight) }), (locked && { locked: locked })), { tags: sdk_model_1.insightTags(insight).join(" "), summary: sdk_model_1.insightSummary(insight) }),
    };
};
//# sourceMappingURL=InsightConverter.js.map